export default __webpack_public_path__ + "static/media/foooter_image.2311335f.png";